import { EvoModel } from './evo-model';

export class Permission extends EvoModel {
  public id: string;
  public code: string;
  public name: string;
  public description: string;
  public product: string;
  public group: PermissionGroup | string;
  public createdAt: string | Date;
  public updatedAt: string | Date;
}

export enum QualityPermissions {
  ALL_PERMISSIONS = 'ALL_PERMISSIONS',
  DASHBOARD = 'DASHBOARD',
  CREATE_SEGMENTS = 'CREATE_SEGMENTS',
  EDIT_SEGMENTS = 'EDIT_SEGMENTS',
  VIEW_SEGMENTS = 'VIEW_SEGMENTS',
  ACTIVATE_SEGMENTS = 'ACTIVATE_SEGMENTS',
  CREATE_OPERATIONS = 'CREATE_OPERATIONS',
  EDIT_OPERATIONS = 'EDIT_OPERATIONS',
  VIEW_OPERATIONS = 'VIEW_OPERATIONS',
  CREATE_CHECKLISTS = 'CREATE_CHECKLISTS',
  EDIT_CHECKLISTS = 'EDIT_CHECKLISTS',
  VIEW_CHECKLISTS = 'VIEW_CHECKLISTS',
  DOWNLOAD_CONTESTATION_REPORTS = 'DOWNLOAD_CONTESTATION_REPORTS',
  VIEW_CONTESTATION_REPORTS = 'VIEW_CONTESTATION_REPORTS',
  DOWNLOAD_INTERACTION_REPORTS = 'DOWNLOAD_INTERACTION_REPORTS',
  VIEW_INTERACTION_REPORTS = 'VIEW_INTERACTION_REPORTS',
  VIEW_INTERACTION_CHECKLIST_ITEM_CONCEPT = 'VIEW_INTERACTION_CHECKLIST_ITEM_CONCEPT',
  DOWNLOAD_ITEM_REPORTS = 'DOWNLOAD_ITEM_REPORTS',
  VIEW_ITEM_REPORTS = 'VIEW_ITEM_REPORTS',
  VIEW_INTERACTION_COMMENT_REPORTS = 'VIEW_INTERACTION_COMMENT_REPORTS',
  DOWNLOAD_INTERACTION_COMMENT_REPORTS = 'DOWNLOAD_INTERACTION_COMMENT_REPORTS',
  DOWNLOAD_AGENT_AVERAGE_REPORTS = 'DOWNLOAD_AGENT_AVERAGE_REPORTS',
  CREATE_INTERACTIONS = 'CREATE_INTERACTIONS',
  VIEW_ALL_INTERACTIONS = 'VIEW_ALL_INTERACTIONS',
  VIEW_OWNED_INTERACTION = 'VIEW_OWNED_INTERACTION',
  VIEW_INTERACTIONS_DETAILS = 'VIEW_INTERACTIONS_DETAILS',
  VIEW_INTERACTIONS_CUSTOMER_DETAILS = 'VIEW_INTERACTIONS_CUSTOMER_DETAILS',
  REVIEW_INTERACTIONS = 'REVIEW_INTERACTIONS',
  EVALUATE_INTERACTIONS = 'EVALUATE_INTERACTIONS',
  RELEASE_INTERACTIONS = 'RELEASE_INTERACTIONS',
  IMPORT_INTERACTIONS = 'IMPORT_INTERACTIONS',
  DISCARD_INTERACTION = 'DISCARD_INTERACTION',
  ACCEPT_EVALUATION = 'ACCEPT_EVALUATION',
  CONTEST_EVALUATION = 'CONTEST_EVALUATION',
  CONTEST_EVALUATION_ATTACHMENT = 'CONTEST_EVALUATION_ATTACHMENT',
  REPLY_CONTESTATION = 'REPLY_CONTESTATION',
  REPLY_CONTESTATION_ATTACHMENT = 'REPLY_CONTESTATION_ATTACHMENT',
  REPLICA_REPLY_CONTESTATION = 'REPLICA_REPLY_CONTESTATION',
  REPLY_REPLICA = 'REPLY_REPLICA',
  TREPLICA_REPLY_REPLICA = 'TREPLICA_REPLY_REPLICA',
  REPLY_TREPLICA = 'REPLY_TREPLICA',
  INTERNAL = 'INTERNAL',
  ACCEPT_FEEDBACK = 'ACCEPT_FEEDBACK',
  APPLY_FEEDBACK = 'APPLY_FEEDBACK',
  VIEW_INTERACTION_INSIGHT = 'VIEW_INTERACTION_INSIGHT',
  COPY_TRANSCRIPTION = 'COPY_TRANSCRIPTION',
  AUDIO_DOWNLOAD = 'AUDIO_DOWNLOAD',
  VIEW_FLOWS = 'VIEW_FLOWS',
  CREATE_FLOWS = 'CREATE_FLOWS',
  EDIT_FLOWS = 'EDIT_FLOWS',
  VIEW_JUSTIFICATIONS = 'VIEW_JUSTIFICATIONS',
  CREATE_JUSTIFICATIONS = 'CREATE_JUSTIFICATIONS',
  EDIT_JUSTIFICATIONS = 'EDIT_JUSTIFICATIONS',
  TRAINING_ACCESS = 'TRAINING_ACCESS',
  CREATE_TRAINING = 'CREATE_TRAINING',
  VIEW_TRANSCRIPTION = 'VIEW_TRANSCRIPTION',

  VIEW_REPORTS = 'VIEW_REPORTS',
  VIEW_FRAGMENTS = 'VIEW_FRAGMENTS',
  EDIT_CONFORMING_ANSWER = 'EDIT_CONFORMING_ANSWER',
  GEN_AI_CHAT = 'GEN_AI_CHAT',
  GEN_AI_CHAT_EVA_2 = 'GEN_AI_CHAT_EVA_2',
  GEN_AI_INTERACTION_CHAT = 'GEN_AI_INTERACTION_CHAT',
  GEN_AI_CHAT_CONFIGURATION = 'GEN_AI_CHAT_CONFIGURATION',

  VIEW_ALL_INTERACTION_MANAGEMENT = 'VIEW_ALL_INTERACTION_MANAGEMENT',
  INTERACTION_MANAGEMENT_REPROCESS = 'INTERACTION_MANAGEMENT_REPROCESS',
  INTERACTION_MANAGEMENT_REPROCESS_DASHBOARD = 'INTERACTION_MANAGEMENT_REPROCESS_DASHBOARD',
  INTERACTION_MANAGEMENT_DISCARD = 'INTERACTION_MANAGEMENT_DISCARD',
  INTERACTION_MANAGEMENT_ALTER_DEADLINE = 'INTERACTION_MANAGEMENT_ALTER_DEADLINE',
  INTERACTION_MANAGEMENT_MASS_ANSWER = 'INTERACTION_MANAGEMENT_MASS_ANSWER',

  CREATE_AI_CONTESTATION = 'CREATE_AI_CONTESTATION',
  VIEW_AI_CONTESTATION = 'VIEW_AI_CONTESTATION',
  EDIT_AI_CONTESTATION = 'EDIT_AI_CONTESTATION',
  REMOVE_AI_CONTESTATION = 'REMOVE_AI_CONTESTATION',
  PREVIEW_GENAI_CONTESTATION = 'PREVIEW_GENAI_CONTESTATION',

  CREATE_PUBLIC_COMMENTS = 'CREATE_PUBLIC_COMMENTS',
  CREATE_PRIVATE_COMMENTS = 'CREATE_PRIVATE_COMMENTS',

  VIEW_PUBLIC_COMMENTS = 'VIEW_PUBLIC_COMMENTS',

  DELETE_PUBLIC_COMMENTS = 'DELETE_PUBLIC_COMMENTS',
  DELETE_PRIVATE_COMMENTS = 'DELETE_PRIVATE_COMMENTS',

  VIEW_PRE_MANUAL_INTERACTIONS = 'VIEW_PRE_MANUAL_INTERACTIONS',
  EDIT_PRE_MANUAL_INTERACTIONS = 'EDIT_PRE_MANUAL_INTERACTIONS',

  VIEW_METADATA_VISIBILITY = 'VIEW_METADATA_VISIBILITY',
  EDIT_METADATA_VISIBILITY = 'EDIT_METADATA_VISIBILITY',

  ACCEPT_REJECT_AI_RESPONSE = 'ACCEPT_REJECT_AI_RESPONSE',
  GENERATE_AGENT_FEEDBACK = 'GENERATE_AGENT_FEEDBACK',
  IS_AGENT = 'IS_AGENT',
}

export enum PermissionGroup {
  USERS = 'Usuários',
  SEGMENTS = 'Segmentos',
  OPERATIONS = 'Operações',
  CHECKLISTS = 'Check List',
  REPORTS = 'Relatórios',
  INTERACTIONS = 'Interações',
  ORGANIZATIONS = 'Organizações',
  ROLES = 'Perfis',
  FLOWS = 'Fluxos',
  JUSTIFICATIONS = 'Justificativas',
  DASHBOARDS = 'Dashboards',
  TRAINING_PLATAFORM = 'Training',
  TRAINING = 'Treinamentos',
  GEN_AI = 'IA Generativa',
  CONTESTATION_AI = 'Contestação IA',
  METADATA = 'Metadados',
}
